module.exports = __webpack_public_path__ + "static/media/logo-coopanest.600bf8fd.png";